import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col p-4"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col p-4"
}
const _hoisted_4 = { class: "flex flex-col bg-brand-dark-gray p-5 rounded-lg space-y-4" }
const _hoisted_5 = { class: "flex flex-col my-auto px-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-brand-light-gray font-medium text-lg text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "text-white font-medium text-lg text-center"
}
const _hoisted_8 = {
  key: 2,
  class: "py-16 m-auto"
}
const _hoisted_9 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_10 = {
  key: 0,
  class: "bg-brand-light-gray text-brand-black rounded-md w-full flex"
}
const _hoisted_11 = { class: "rounded-md overflow-hidden" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_photo_consumer = _resolveComponent("photo-consumer")!
  const _component_photo_provider = _resolveComponent("photo-provider")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading && !_ctx.isFriendsWithAuthUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "flex flex-col bg-brand-dark-gray p-5 rounded-lg space-y-4" }, [
            _createElementVNode("div", { class: "flex flex-col my-auto px-3" }, [
              _createElementVNode("div", { class: "text-brand-light-gray font-medium text-lg text-center" }, "Send a friend request – if they accept, you'll be able to view their photo gallery.")
            ])
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.gallery.length && _ctx.isFriendsWithAuthUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.isAuthUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "They have not added any photos yet."))
                : _createCommentVNode("", true),
              (_ctx.isAuthUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Any images you add to your gallery will show here."))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isAuthUser)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.manageGallery && _ctx.manageGallery(...args))),
                  class: "w-full flex bg-black rounded-full px-8 h-14 font-medium text-xl text-white transition-all"
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                    _createElementVNode("div", { class: "my-auto pt-0.5" }, [
                      _createElementVNode("div", null, "Add images")
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            class: "animate-spin h-5 w-5 text-brand-light-gray",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.gallery.length && _ctx.isFriendsWithAuthUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass([{
            'grid-cols-2' : _ctx.authUser.subscribed || _ctx.authUser.id === _ctx.userId,
            'grid-cols-7' : !_ctx.authUser.subscribed || _ctx.authUser.id !== _ctx.userId
          }, "flex grid gap-4 p-4"])
          }, [
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "m-auto fill-current",
                    width: "30",
                    height: "24",
                    viewBox: "0 0 30 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", { d: "M3.9375 4.625C2.95951 4.625 2.02158 5.0135 1.33004 5.70504C0.638503 6.39658 0.25 7.33451 0.25 8.3125L0.25 19.375C0.25 20.353 0.638503 21.2909 1.33004 21.9825C2.02158 22.674 2.95951 23.0625 3.9375 23.0625H26.0625C27.0405 23.0625 27.9784 22.674 28.67 21.9825C29.3615 21.2909 29.75 20.353 29.75 19.375V8.3125C29.75 7.33451 29.3615 6.39658 28.67 5.70504C27.9784 5.0135 27.0405 4.625 26.0625 4.625H23.9016C22.9237 4.62479 21.9859 4.23615 21.2946 3.54456L19.7679 2.01794C19.0766 1.32635 18.1388 0.937709 17.1609 0.9375H12.8391C11.8612 0.937709 10.9234 1.32635 10.2321 2.01794L8.70544 3.54456C8.01406 4.23615 7.07628 4.62479 6.09837 4.625H3.9375ZM4.85938 8.3125C4.61488 8.3125 4.3804 8.21537 4.20751 8.04249C4.03463 7.8696 3.9375 7.63512 3.9375 7.39062C3.9375 7.14613 4.03463 6.91165 4.20751 6.73876C4.3804 6.56588 4.61488 6.46875 4.85938 6.46875C5.10387 6.46875 5.33835 6.56588 5.51124 6.73876C5.68412 6.91165 5.78125 7.14613 5.78125 7.39062C5.78125 7.63512 5.68412 7.8696 5.51124 8.04249C5.33835 8.21537 5.10387 8.3125 4.85938 8.3125ZM21.4531 12.9219C21.4531 14.6334 20.7732 16.2747 19.563 17.4849C18.3529 18.6951 16.7115 19.375 15 19.375C13.2885 19.375 11.6471 18.6951 10.437 17.4849C9.22676 16.2747 8.54688 14.6334 8.54688 12.9219C8.54688 11.2104 9.22676 9.56902 10.437 8.35883C11.6471 7.14863 13.2885 6.46875 15 6.46875C16.7115 6.46875 18.3529 7.14863 19.563 8.35883C20.7732 9.56902 21.4531 11.2104 21.4531 12.9219Z" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.authUser.subscribed || _ctx.authUser.id === _ctx.userId)
              ? (_openBlock(), _createBlock(_component_photo_provider, { key: 1 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (media) => {
                      return (_openBlock(), _createBlock(_component_photo_consumer, {
                        key: media.id,
                        src: media.url
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_ion_img, {
                              src: media.thumbnail ?? media.url,
                              class: "rounded-md object-cover aspect-square view-box w-full pointer-events-none"
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["src"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.authUser.subscribed && _ctx.authUser.id !== _ctx.userId)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.gallery, (media) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.notSubscribed && _ctx.notSubscribed(...args))),
                    class: "rounded-md overflow-hidden",
                    key: media.id,
                    src: media.url
                  }, [
                    _createVNode(_component_ion_img, {
                      src: media.thumbnail ?? media.url,
                      class: "object-cover aspect-square view-box w-full pointer-events-none"
                    }, null, 8, ["src"])
                  ], 8, _hoisted_12))
                }), 128))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.showInfiniteScroll)
            ? (_openBlock(), _createBlock(_component_ion_infinite_scroll, {
                key: 0,
                onIonInfinite: _ctx.loadMore
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_infinite_scroll_content, {
                    class: "text-white",
                    "loading-spinner": "crescent"
                  })
                ]),
                _: 1
              }, 8, ["onIonInfinite"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}